import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Box, Button, Collapse, Divider, Drawer, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_CONFIG } from '../components/NavBar/MenuItems';


interface Props {
  open: boolean;
  onClose: () => void;
  role: string;
  category: string;
}

export default function AppSidebar({ open, onClose, role, category }: Props) {
  const navigate = useNavigate();
  const [openedGroup, setOpenedGroup] = useState<string | null>(null);

  const groupedRoutes = useMemo(() => {
    const allowed = ROUTE_CONFIG.filter(
      (route) =>
        route.showInMenu &&
        route.navGroup &&
        route.canAccess(role as any, category as any)
    );

    return allowed.reduce<Record<string, typeof allowed>>((acc, route) => {
      const key = route.navGroup!;
      if (!acc[key]) acc[key] = [];
      acc[key].push(route);
      return acc;
    }, {});
  }, [role, category]);

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box sx={{ width: 280, pt: 10 }}>
        {Object.entries(groupedRoutes).map(([group, items]) => {
          const isOpen = openedGroup === group;

          return (
            <Box key={group} sx={{ mb: 1 }}>
              <Button
                fullWidth
                onClick={() => setOpenedGroup(isOpen ? null : group)}
                endIcon={isOpen ? <ExpandLess /> : <ExpandMore />}
                sx={{ justifyContent: 'space-between', textTransform: 'none' }}
              >
                <Typography variant="body2">{group}</Typography>
              </Button>

              <Collapse in={isOpen}>
                <Box sx={{ pl: 2, pt: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {items.map((item) => (
                    <Button
                      key={item.path}
                      onClick={() => {
                        navigate(item.path);
                        onClose();
                      }}
                      sx={{ justifyContent: 'flex-start', textTransform: 'none' }}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
              </Collapse>

              <Divider sx={{ mt: 1 }} />
            </Box>
          );
        })}
      </Box>
      
    </Drawer>
  );
}